import React, { useState, useEffect } from 'react';
import Loader from "react-loader-spinner";
import { MdDelete } from 'react-icons/md';
import { useTranslation } from "react-i18next";
import * as processCosts from '../../Redux/Actions/processCost';
import { toastMessage } from '../../utils/toast';
import { useDispatch } from 'react-redux';
import { clearSession, errorHandler } from '../../utils/initiate';
import DropDown from '../Ui/DropDown';
import ChildProcessCostModal from './childProcessCostModal';

const AddProcessCostDetails = ({history}) => {

    const [name, setName] = useState('');
    const [addedData, setAddedData] = useState([]);
    const [attributeName, setAttributeName] = useState('');
    const [processCostID, setProcessCostID] = useState('');
    const [moduleTypeOptions, setModuleTypeOptions] = useState([]);
    const [moduleGroupOptions, setModuleGroupOptions] = useState([]);
    const [moduleType, setModuleType] = useState('');
    const [moduleGroup, setModuleGroup] = useState('');
    const [costAmount, setCostAmount] = useState(0);
    const [sla, setSla] = useState(0);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [showChildProcessCostModal, setShowChildProcessCostModal] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        processCosts.getModuleTypeAndGroups().then(res => {
            if(res && res.data) {
                let moduleTypeData = res.data.moduleTypes && res.data.moduleTypes.map(({key, value}) => ({label: key, value}));
                let moduleGroupData = res.data.moduleGroups && res.data.moduleGroups.map(({id, name}) => ({label: name, value: id}));
                setModuleTypeOptions(moduleTypeData);
                setModuleGroupOptions(moduleGroupData);
            }else{
                toastMessage('error', 'Unable to load the module types and groups');
            }
        }).catch(err => {
            errorHandler(err);
        });
    }, []);

    const handleAddProcessCostData = () => {
        let newData = addedData;
        newData.push({ attributeName, costAmount, sla, moduleType: moduleType.value, moduleGroupId: moduleGroup.value, moduleGroupName: moduleGroup.label, childProcessCostDetails: [] });
        setAttributeName(''); setCostAmount(0); setSla(0); setModuleType(''); setModuleGroup('');
    };

    const handleAddChildProcessCostData = (cAttributeName, cCostAmount, cModuleType, cModuleGroup) => {
        let newData = addedData;
        newData.map((pc, index) => {
            return (
                (index+1 === processCostID) ? 
                    pc.childProcessCostDetails.push({ attributeName: cAttributeName, costAmount: cCostAmount, moduleType: cModuleType.value, moduleGroupId: cModuleGroup.value, moduleGroupName: cModuleGroup.label })
                : pc
        )});
        setShowChildProcessCostModal(false)
    };

    const handleDeleteProcessCostData = (ID) => {
        let newData = addedData;
        newData = newData.filter((processCost, index) => ID !== index+1);
        setAddedData(newData);
    };

    const handleChildDeleteProcessCostData = (parentProcessCostID, childProcessCostID) => {
        let newData = addedData;
        newData = newData.map((parent, index) => {
            let parentID = index+1;
            let filtered = parent.childProcessCostDetails.filter((child, index) => (childProcessCostID !== index+1));
            return (
                (parentProcessCostID === parentID) ? {childProcessCostDetails: filtered, attributeName: parent.attributeName, costAmount: parent.costAmount, moduleGroupName: parent.moduleGroupName, moduleGroupId: parent.moduleGroupId, moduleType: parent.moduleType}
                : parent
        )});
        setAddedData(newData);
    };

    const handleProcessCostData = () => {
        setButtonLoading(true);
        let payload = {
            name,
            processCostDetails: addedData
        };
        processCosts.create(payload).then(res => {
            if(res && res.data){
                toastMessage('success', 'Process cost details added successfully');
                setName(''); setAttributeName(''); setCostAmount(0); setModuleType(''); setModuleGroup(''); setAddedData([]);
            }else{
                toastMessage('error', 'Process cost details added failed');
            }
            setButtonLoading(false);
        }).catch(err => {
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    };

    const handleDisableAddCTA = () => {
        return buttonLoading || (name === '') || (attributeName === '') || !(moduleType.value === 'AAMER_ENTITY' ? costAmount >= 0 : costAmount > 0) || (moduleType.length === 0) || (moduleGroup.length === 0);
    };

    return (
        <div className="row">
            <div className="col-lg-12 col-xxl-12">
                <div className="card border-0 card-stretch">
                    <div className="card-header border-0 py-3">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">{t("mastersManagement.processCost.addProcessCostTitle")}</span>
                        </h3>
                    </div>
                    <div className="card-body pt-0 pb-3">
                        <div className="form-group fv-plugins-icon-container">
                            <label className="mb-1">{t("mastersManagement.processCost.name")}</label>
                            <input placeholder={t("mastersManagement.processCost.namePlaceholder")} type="text" className="form-control" name="name" value={name} onChange={e => setName(e.target.value)} />
                        </div>
                        <div className="form-group fv-plugins-icon-container">
                            <label className="mb-1">{t("mastersManagement.processCost.attributeName")}</label>
                            <input placeholder={t("mastersManagement.processCost.attributeNamePlaceholder")} type="text" className="form-control"
                                name="Attribute Name" value={attributeName} onChange={e => setAttributeName(e.target.value)} />
                        </div>
                        <div className="form-group fv-plugins-icon-container">
                            <label className="mb-1">{t("mastersManagement.processCost.costAmount")}</label>
                            <input placeholder={t("mastersManagement.processCost.costAmountPlaceholder")} type="number" className="form-control"
                                name="Cost Amount" value={costAmount} onChange={e => setCostAmount(parseFloat(e.target.value))} />
                        </div>
                        <DropDown label={t("mastersManagement.processCost.moduleType")} placeholder={t("mastersManagement.processCost.moduleTypePlaceholder")} options={moduleTypeOptions} value={moduleType} onChange={(value) => setModuleType(value)} />
                        <DropDown label={t("mastersManagement.processCost.moduleGroup")} placeholder={t("mastersManagement.processCost.moduleGroupPlaceholder")} options={moduleGroupOptions} value={moduleGroup} onChange={(value) => setModuleGroup(value)} />
                        {/* <div className="form-group fv-plugins-icon-container">
                            <label className="mb-1">VAT</label>
                            <input placeholder={`Enter the vat`} type="text" className="form-control" name="vat" value={vat} onChange={e => setVat(e.target.value)} />
                        </div> */}
                        <div className="form-group fv-plugins-icon-container">
                            <label className="mb-1">{t("mastersManagement.processCost.sla")}</label>
                            <input placeholder={t("mastersManagement.processCost.slaPlaceholder")} type="number" className="form-control"
                                name="SLA" value={sla} onChange={e => setSla(e.target.value)} />
                        </div>
                        <button disabled={handleDisableAddCTA()} onClick={handleAddProcessCostData} type="button" className="btn btn-primary font-weight-bold mb-4">{t("mastersManagement.add.add")}</button>
                        {(addedData.length !== 0) && <>
                            <div className="d-flex flex-column">
                                {addedData.map(({ attributeName, costAmount, sla, moduleType, moduleGroupName, childProcessCostDetails }, index) =>  {
                                    let parentProcessCostID = index+1;
                                    return (
                                        <div className="mb-2" key={parentProcessCostID}>
                                            <div className="d-flex align-items-start mb-1">
                                                <p className="me-2">{parentProcessCostID}.</p>
                                                <div className="me-4">
                                                    <p>{t("mastersManagement.processCost.attributeName")}: {attributeName}</p>
                                                    <p>{t("mastersManagement.processCost.costAmount")}: {costAmount}</p>
                                                    <p>{t("mastersManagement.processCost.moduleType")}: {moduleType}</p>
                                                    <p>{t("mastersManagement.processCost.moduleGroup")}: {moduleGroupName}</p>
                                                    <p>{t("mastersManagement.processCost.sla")}: {sla}</p>
                                                    {(childProcessCostDetails && childProcessCostDetails.length !== 0) && <div className="mt-2 ms-4">
                                                        <p className="text-muted">{t("mastersManagement.processCost.childProcessCostTitle")}</p>
                                                        {childProcessCostDetails.map(({ attributeName: cAN, costAmount: cCA, moduleType: cMT, moduleGroupName: cMG }, index) => {
                                                            let childProcessCostID = index+1;
                                                            return (
                                                                <div className="d-flex">
                                                                    <div className="mb-2" key={childProcessCostID}>
                                                                        <div className="d-flex align-items-start mb-1">
                                                                            <p className="me-2">{childProcessCostID}.</p>
                                                                            <div>
                                                                                <p>{t("mastersManagement.processCost.attributeName")}: {cAN}</p>
                                                                                <p>{t("mastersManagement.processCost.costAmount")}: {cCA}</p>
                                                                                <p>{t("mastersManagement.processCost.moduleType")}: {cMT}</p>
                                                                                <p>{t("mastersManagement.processCost.moduleGroup")}: {cMG}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <MdDelete className="c-pointer ms-2 font-20" onClick={() => handleChildDeleteProcessCostData(parentProcessCostID, childProcessCostID)} />
                                                                </div>
                                                            )}
                                                        )}
                                                    </div>}
                                                </div>
                                                <button onClick={() => {setShowChildProcessCostModal(true); setProcessCostID(parentProcessCostID)}} type="button" className="btn btn-primary font-weight-bold font-12">
                                                    {t("mastersManagement.processCost.addChildProcessCost")}
                                                </button>
                                                <MdDelete className="c-pointer ms-2 font-20" onClick={() => handleDeleteProcessCostData(parentProcessCostID)} />
                                            </div>
                                        </div>
                                    )}
                                )}
                            </div>
                            <button disabled={buttonLoading} onClick={handleProcessCostData} type="button" className="d-flex align-items-center btn btn-primary font-weight-bold mb-3">
                                {t("mastersManagement.processCost.submit")} {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </>}
                        {showChildProcessCostModal && <ChildProcessCostModal t={t} showModal={showChildProcessCostModal} moduleTypeOptions={moduleTypeOptions} moduleGroupOptions={moduleGroupOptions} handleOk={handleAddChildProcessCostData} handleCancel={() => setShowChildProcessCostModal(false)} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddProcessCostDetails;